import * as React from 'react'

import { Box } from 'lucide-react'
import { makeObservable, observable, runInAction } from 'mobx'
import { inject, observer } from 'mobx-react'

import DesktopEventStore from '~/client/src/desktop/stores/EventStore/DesktopEvents.store'
import FacetButton from '~/client/src/shared/components/Filters/components/FacetButton/FacetButton'
import { Button } from '~/client/src/shared/components/shadcn-ui/button'
import Localization from '~/client/src/shared/localization/LocalizationManager'

import BaseGroupingOptionsStore from './BaseGroupingOptions.store'
import BaseGroupingOptionsPopup from './components/BaseGroupingOptionsPopup/BaseGroupingOptionsPopup'

import './BaseGroupingOptions.scss'

// localization: translated

interface IGroupingOptions {
  store: BaseGroupingOptionsStore
  forceClose: boolean
  eventsStore?: DesktopEventStore
  isDisabled?: boolean
  CustomHandleButton?: typeof Button
  shouldHideBandCreation?: boolean
  leftIcon?: JSX.Element
  shouldRenderRightIcon?: boolean
}

@inject('eventsStore')
@observer
export default class BaseGroupingOptions extends React.Component<IGroupingOptions> {
  @observable.ref private localProps: IGroupingOptions = null
  private readonly clearPostEventCallback: () => void

  public constructor(props: IGroupingOptions) {
    super(props)
    this.localProps = props

    this.clearPostEventCallback = props.eventsStore.addPostEventCallback(
      this.store.onActionRequest,
    )
    makeObservable(this)
  }

  public UNSAFE_componentWillMount() {
    this.store.setSelectedBand()
  }

  public componentDidUpdate() {
    runInAction(() => {
      if (this.props.forceClose) {
        this.store.isShown = false
      }
    })
  }

  public componentWillUnmount() {
    if (this.clearPostEventCallback) {
      this.clearPostEventCallback()
    }
  }

  public render() {
    const { shouldHideBandCreation } = this.localProps
    return (
      <>
        {this.renderHandleButton()}
        {this.store.isShown && (
          <BaseGroupingOptionsPopup
            store={this.store}
            shouldHideBandCreation={shouldHideBandCreation}
          />
        )}
      </>
    )
  }

  private get store() {
    return this.localProps.store
  }

  private renderHandleButton() {
    const { isDisabled, CustomHandleButton } = this.localProps
    const { groupByCaption, toggleGroupingOptions, isShown } = this.store

    if (CustomHandleButton) {
      return (
        <CustomHandleButton
          variant="outline"
          onClick={toggleGroupingOptions}
          disabled={isDisabled}
          aria-expanded={isShown}
        >
          <Box data-icon="inline-start" size={16} />
          {groupByCaption}
        </CustomHandleButton>
      )
    }

    return (
      <FacetButton
        type="group"
        label={this.groupByCaption}
        isOpen={isShown}
        isActive={true}
        isDisabled={isDisabled}
        onClick={toggleGroupingOptions}
      />
    )
  }

  private get groupByCaption() {
    const { groupByCaption } = this.store
    return groupByCaption
      ? Localization.translator.groupByX(groupByCaption)
      : Localization.translator.groupBy
  }
}
